import { Controller } from "@hotwired/stimulus"

// Reads `year_level`, `tour_date`, `enquiry_type` from the URL query string
// (set by the homepage searchbar's GET form submission) and pre-fills the
// contact form's Message textarea with a templated string. Idempotent —
// only runs when at least one of the three params is present, and only
// fills `description` when it is currently empty (so a partially filled
// form isn't overwritten on a hot-reload).
export default class extends Controller {
  static YEAR_LABELS = {
    "foundation": "Foundation",
    "year-1": "Year 1",
    "year-2": "Year 2",
    "year-3": "Year 3",
    "year-4": "Year 4",
    "year-5": "Year 5",
    "year-6": "Year 6"
  }

  static ENQUIRY_LABELS = {
    "tour": "school tour",
    "enrol": "enrolment",
    "general": "general enquiry"
  }

  connect() {
    const params = new URLSearchParams(window.location.search)
    const year = params.get("year_level")
    const date = params.get("tour_date")
    const kind = params.get("enquiry_type")
    if (!year && !date && !kind) return

    const textarea = this.element.querySelector('textarea[name="contact_form[description]"]')
    if (!textarea || textarea.value.trim() !== "") return

    textarea.value = this.composeMessage({ year, date, kind })
  }

  composeMessage({ year, date, kind }) {
    const yearLabel = year ? (this.constructor.YEAR_LABELS[year] || year) : null
    const kindLabel = kind ? (this.constructor.ENQUIRY_LABELS[kind] || kind) : "school tour"
    const parts = [`Hi — I'd like to book a ${kindLabel}`]
    if (yearLabel) parts.push(`for ${yearLabel}`)
    if (date) parts.push(`ideally on ${date}`)
    return parts.join(" ") + "."
  }
}
